import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { gradSchoolGuideContent } from '../content';

const degreeTypesDetail = [
  ...gradSchoolGuideContent.degreeTypes.undergraduate.map(
    (d) => `${d.name} (${d.duration}): ${d.description}`,
  ),
  ...gradSchoolGuideContent.degreeTypes.graduate.map(
    (d) =>
      `${d.name} (${d.duration}): ${d.description}${d.examples ? ` — ${d.examples.join(', ')}` : ''}`,
  ),
].join('\n');

const frameworkDetail = [
  gradSchoolGuideContent.framework.description,
  ...gradSchoolGuideContent.framework.categories.map(
    (c) => `${c.category} (${c.percentage}%): ${c.description}`,
  ),
  gradSchoolGuideContent.framework.takeaway,
].join('\n');

const keyInsightsDetail = gradSchoolGuideContent.faq
  .map((faq) => `${faq.question}\n${faq.answer}`)
  .join('\n\n');

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Types of Degrees',
    description:
      'Modal explaining undergraduate and graduate degree types, durations, and descriptions.',
    detail: degreeTypesDetail,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'How Backrs Helps',
    description: gradSchoolGuideContent.backrsHelps.features.map((f) => f.description).join(' '),
    detail: frameworkDetail,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Explore Tools',
    description: 'Two cards linking to the Majors-Careers explorer and Explore Majors search.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Key Insights',
    description: 'Key insights for parents and students about graduate school decisions.',
    detail: keyInsightsDetail,
  });
};
